import { Component, OnInit, HostListener } from '@angular/core';
import { OverlayContainer } from '@angular/cdk/overlay';
import { ThemeService, WindowRefService } from '@app/core';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-content-layout',
  templateUrl: './content-layout.component.html',
  styleUrls: ['./content-layout.component.scss']
})
export class ContentLayoutComponent implements OnInit {
  private overlayContainer: OverlayContainer;
  theme = 'my-light-theme';
  isDarkTheme: Observable<boolean>;
  isSticky: boolean = false;
  bookDirect: boolean;
  
  @HostListener('window:scroll', ['$event'])
  checkScroll() {
    this.isSticky = window.pageYOffset >= 200;
  }

  constructor(private themeService: ThemeService, private winRef: WindowRefService) {}

  ngOnInit() {
    this.isDarkTheme = this.themeService.isDarkTheme;
    this.bookDirect = this.winRef.appConfigSite.bookdirect;
    if (this.overlayContainer) {
      this.overlayContainer.getContainerElement().classList.add(this.theme);
    }
  }

  onThemeChange(theme: boolean) {
    this.themeService.setDarkTheme(theme);
    this.theme = (theme) ? 'my-dark-theme' : 'my-light-theme';
    if (this.overlayContainer) {
      const overlayContainerClasses = this.overlayContainer.getContainerElement().classList;
      const themeClassesToRemove = Array.from(overlayContainerClasses).filter((item: string) => item.includes('-theme'));
      if (themeClassesToRemove.length) {
        overlayContainerClasses.remove(...themeClassesToRemove);
      }
      overlayContainerClasses.add(this.theme);
    }
  }

}
